import Utils from '../utils';

const { Communication, PrintUtil } = Utils;

export default class MediaGen {
	static queue = { domestic: [], cn22: [], cp72: [], batchCM: [] };

	static is4x6Layout(printLayout = '') {
		return [
			'GPPlus',
			'GPPlusIntl',
			'NormalUps',
			'NormalDhl',
			'NormalFedex',
			'NormalCN22',
			'NormalCP72',
			'Normal4X6',
			'Normal4X6CN22',
			'Normal4X6CP72',
			'Normal6X4CN22',
			'Normal6X4CP72',
			'Return',
		].includes(printLayout);
	}

	static isBatchCertifiedMail(printLayout = '', labelUrls = []) {
		return (
			labelUrls.length > 1 &&
			(printLayout.includes('Sdc3610') || printLayout.includes('Sdc3710'))
		);
	}

	/**
	 * Returns a boolean value indicating whether the print can be stitched together using MediaGen.
	 *
	 * Eligibile prints:
	 * - Shipping labels and rolls with 4x6 printLayout, which are all non-USPS domestic labels
	 * - Batch Certified Mail 3610 and 3710 (Note: not supported as of Reprint first phase)
	 */
	static canStitch(printLayout, labelUrls, labelFormat) {
		return (
			(this.is4x6Layout(printLayout) || this.isBatchCertifiedMail(printLayout, labelUrls)) &&
			labelFormat !== 'pdf'
		);
	}

	static async stitch(labelUrls = [], layoutConfig) {
		const {
			startPos = 1,
			sheet, // sheet type (NetStamps, ShippingLabel, Envelope, CM, Roll)
			series, // the specific sheet (serial number for netstamps, carrier for shipping labels, envelope values, certified mail numbers, form)
			isThermal,
			isThinClient,
			labelFormat,
			printerName,
			printerTray,
			printerPaper,
			printerPaperOrientation,
			printLayout,
			printOn,
		} = layoutConfig;
		let { printerPaperWidth, printerPaperHeight, margin } = layoutConfig;

		if (!this.canStitch(printLayout, labelUrls) && !isThinClient) {
			return labelUrls;
		}

		if (isThermal) {
			printerPaperHeight = '6';
			printerPaperWidth = '4';
			margin = PrintUtil.getPrintMarginsForThermalLabels(printerName, printOn);
		}

		const response = await Communication.createMediaGen({
			labelUrls,
			startPos,
			sheet,
			series,
			isThermal,
			isThinClient,
			labelFormat,
			printerName,
			printerTray,
			printerPaper,
			printerPaperWidth,
			printerPaperHeight,
			printerPaperOrientation,
			margin,
		});

		// caller handles the success/failure response
		return response;
	}

	static queueLabel(labelData) {
		const { labelUrls, sheet } = labelData;

		for (let i = 0; i < labelUrls.length; i++) {
			switch (sheet) {
				case 'ShippingLabel':
				case 'Roll':
					this.queue.domestic.push(labelData);
					break;
				case 'CN22':
					this.queue.cn22.push(labelData);
					break;
				case 'CP72':
					this.queue.cp72.push(labelData);
					break;
				case 'CM':
					this.queue.batchCM.push(labelData);
					break;
				default:
					break;
			}
		}
	}

	static _getNextLabel() {
		if (this.queue.domestic.length > 0) {
			return this.queue.domestic.shift();
		} else if (this.queue.cn22.length > 0) {
			return this.queue.cn22.shift();
		} else if (this.queue.cp72.length > 0) {
			return this.queue.cp72.shift();
		} else if (this.queue.batchCM.length > 0) {
			return this.queue.batchCM.shift();
		}
	}
}
